import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";

export default function LoginPage() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (user) navigate("/app");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(form.email, form.password);
      navigate("/app");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAF8] flex flex-col">
      <header className="container-bsp h-16 flex items-center">
        <Link to="/" className="flex items-center gap-2" data-testid="login-logo">
          <div className="w-8 h-8 rounded-md bg-[#1A1F3D] flex items-center justify-center">
            <Sparkles className="w-4 h-4 text-[#D4A853]" />
          </div>
          <span className="font-display text-xl text-[#1A1F3D]">BrandSnapPro™</span>
        </Link>
      </header>
      <main className="flex-1 flex items-center justify-center px-4 py-10">
        <div className="w-full max-w-md bsp-card p-8 md:p-10">
          <span className="eyebrow">Members</span>
          <h1 className="font-display text-3xl text-[#1A1F3D] mt-3">Welcome back.</h1>
          <p className="text-[#52525b] mt-2">Log in to continue your photo system.</p>
          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="login-form">
            <div>
              <label className="text-sm font-medium text-[#1A1F3D]">Email</label>
              <input
                type="email"
                required
                className="bsp-input mt-1"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                data-testid="login-email"
              />
            </div>
            <div>
              <label className="text-sm font-medium text-[#1A1F3D]">Password</label>
              <input
                type="password"
                required
                className="bsp-input mt-1"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                data-testid="login-password"
              />
            </div>
            <button type="submit" disabled={submitting} className="btn-primary w-full justify-center mt-2" data-testid="login-submit">
              {submitting ? "Logging in…" : "Log in"}
            </button>
          </form>
          <div className="mt-6 flex items-center justify-between text-sm">
            <Link to="/forgot-password" className="gold-link" data-testid="forgot-password-link">Forgot password?</Link>
            <Link to="/" className="text-[#52525b] hover:text-[#1A1F3D]">Don't have an account? <span className="text-[#1A1F3D] font-medium">Get access</span></Link>
          </div>
        </div>
      </main>
    </div>
  );
}
